import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import * as RecordRTC from 'recordrtc';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {
 	
  private file=null;

  constructor(public dialogRef: MatDialogRef<VideoDialogComponent>,private domSanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close();
  }

	fileChange(event) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
      this.file = fileList[0]
    }
	}

  deleteVideo(){
  	this.file=null;
  }

  onSave() {
    this.dialogRef.close(this.file);
  }
}
